<template>
  <div class="header">
    <b-row>
      <b-col cols="2">Order No.</b-col>
      <b-col cols="4">Size / Type</b-col>
      <b-col cols="3">Files</b-col>
      <b-col cols="3" class="text-center">Print File Statuses</b-col>
    </b-row>
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>
  .header{
    margin: 0 30px 3px 30px;
    background-color:#535c68;
    border-radius: 5px;
    color: #fff;
    padding: 10px 20px;
    font-size: 13px;
    text-transform: uppercase;
  }
</style>